import callAPI from '../ApiConfig'

const mainUnits = async (props) => {
    
    
    return await callAPI({
        route:"main_units/by_account_id",
        method:"get",
        signal:props?.signal,
        params:props?.params,
    })
    
}

const renewRequest = async (props) => { 
    return await callAPI({
        fullURL:process.env.REACT_APP_API_CAR_REGISTRATION_PORTAL_URL+"external_vehicle_renewal_subscription",
        method:"post",
        signal:props?.signal,
        params:props?.params,
        data:props?.data,
        headers:{
            "Authorization":process.env.REACT_APP_API_CRP_TOKEN
        }
    })
 }


const mainUnitsAPI={
    mainUnits:mainUnits,
    renewRequest:renewRequest

}
export default mainUnitsAPI